module.exports = __webpack_public_path__ + "static/media/categories.e5812791.svg";